export var isDev = (IS_DEV === true);
export var isProd = !isDev;
export var isServer = (IS_SERVER === true);
export var isClient = !isServer;
